import stockAPI from "@/utility/api.js";

const state = {
  surveyAll: {},
  surveyOwner: {},
  oneSurvey: {}
};

const getters = {
  surveyAllList(state) {
    const initData = [
      {
        id: 1,
        title: "研究標題",
        released_at: "2020-08-29",
        user: {
          id: 2,
          name: "sojtest"
        }
      }
    ];
    if (!state.surveyAll.data) {
      return initData;
    } else {
      return state.surveyAll.data;
    }
  },
  surveyOwnerList(state) {
    const initData = [
      {
        id: 1,
        title: "研究標題",
        released_at: "2020-08-29",
        user: {
          id: 2,
          name: "sojtest"
        }
      }
    ];
    if (!state.surveyOwner.data) {
      return initData;
    } else {
      return state.surveyOwner.data;
    }
  },
  oneSurvey(state) {
    const initData = {
      id: 5,
      title: "研究標題",
      released_at: "2020-08-29",
      content: "<p>編輯器內文</p>",
      user: {
        id: 2,
        name: "sojtest",
        is_news_owner: false
      },
      is_admin: false
    };
    if (!state.oneSurvey.id) {
      return initData;
    } else {
      return state.oneSurvey;
    }
  },
  paginationInSurveyOwner(state) {
    //remove data key in paginationData
    // eslint-disable-next-line no-unused-vars
    const { data, ...paginationData } = state.surveyOwner;
    return paginationData;
  },
  paginationInSurveyAll(state) {
    //remove data key in paginationData
    // eslint-disable-next-line no-unused-vars
    const { data, ...paginationData } = state.surveyAll;
    return paginationData;
  }
};

const mutations = {
  surveyAll(state, res) {
    state.surveyAll = { ...res };
  },
  surveyOwner(state, res) {
    state.surveyOwner = { ...res };
  },
  oneSurvey(state, res) {
    state.oneSurvey = { ...res };
  },
  oneSurveyTitle(state, res) {
    state.oneSurvey.title = res;
  },
  oneSurveyReleasedAt(state, res) {
    state.oneSurvey.released_at = res;
  },
  oneSurveyContent(state, res) {
    state.oneSurvey.content = res;
  }
};

const actions = {
  async fetchSurveyAll({ getters, commit }, page) {
    const stockId = getters.outputOfStockSymbol;
    const res = await stockAPI.GET(
      `api/stock/${stockId}/research?page=${page}`
    );
    if (res) {
      commit("surveyAll", res);
      return Promise.resolve();
    }
  },
  async fetchSurveyOwner({ getters, commit }, page) {
    const stockId = getters.outputOfStockSymbol;
    const res = await stockAPI.GET(
      `api/stock/${stockId}/user/research?page=${page}`
    );
    if (res) {
      commit("surveyOwner", res);
      return Promise.resolve();
    }
  },
  async fetchOneSurvey({ commit }, oneSurveyId) {
    const res = await stockAPI.GET(`api/research/${oneSurveyId}`);
    if (res) {
      commit("oneSurvey", res);
      return Promise.resolve();
    }
  },
  createOneSurvey({ getters }, formData) {
    const stockId = getters.outputOfStockSymbol;
    return stockAPI.POST(`api/stock/${stockId}/research`, formData);
  },
  // eslint-disable-next-line no-unused-vars
  deleteOneSurvey({ state }, selectedList) {
    return stockAPI.DELETE(`api/researches`, selectedList);
  },
  updateOneSurvey({ getters }, formData) {
    const stockId = getters.outputOfStockSymbol;
    const oneSurveyId = getters.oneSurvey.id;
    return stockAPI.PUT(
      `api/stock/${stockId}/research/${oneSurveyId}`,
      formData
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
